<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CandidateSideNavLayout></CandidateSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <h1>Quiz</h1>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12">
                                        <div class="quizTable">
                                            <table>
                                            <thead>
                                            <tr>
                                                <th class="sno">#</th>
                                                <th class="quizName">Quiz Name</th>
                                                <th class="noQuse">No. of Questions</th>
                                                <th class="tMarks" >Total Marks</th>
                                                <th class="time" >Time Limit (In Minutes)</th>
                                                <th class="timetaken" >Time Taken</th>
                                                <th class="result">Results</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(quiz, index) in quizes">
                                                    <td class="sno">{{index + 1}}</td>
                                                    <td>{{quiz.name}}</td>
                                                    <td>{{quiz.total_questions}}</td>
                                                    <td>{{quiz.total_marks}}</td>
                                                    <td>{{quiz.total_time}}</td>
                                                    <td>{{quiz.timeTaken}}</td>
                                                    <td>
                                                      <div v-if="quiz.is_played">
                                                        <span v-if="quiz.obtained_marks" v-html="quiz.obtained_marks"></span><span v-else>0 </span> / {{quiz.total_marks}}
                                                      </div>
                                                      <div class="view-all" v-else>
                                                        <router-link :to="{path: '/dashboard/quiz-view?id=' + quiz.quiz_enc_id}">Take Quiz</router-link>
                                                      </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CandidateSideNavLayout from '../../components/CandidateSideNavLayout.vue'
    import axios from "axios";
    import {requestHeaders} from "../../_helpers/apiHelper";

    export default {
        components:{
            CandidateSideNavLayout,
        },
        data(){
            return{
                quizes: [],
            }
        },
        mounted(){
            this.getQuizzesList();
        },
        methods:{
            getQuizzesList() {
                // this.loaderShow();
                var t = this;
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/quiz/get-quizzes`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.quizes = response['data']['response']['data'];
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .sno{
        width: 5%;
        text-align: center;
    }
    .quizName{
        width: 30%;
    }
    .result{
        width: 15%;
    }
    .noQuse, .tMarks, .time, .timetaken{
        width: 10%;
    }
    .quizTable{
        padding: 0 15px 15px;
    }
    table {
        width: 100%;
        border-collapse: collapse;
    }
    /* Zebra striping */
    tr:nth-of-type(odd) {
        background: #f7f7f7;
    }
    th {
        background: #00a0e3;
        color: #fff;
        font-weight: 500;
        padding: 10px 8px;
    }
    td, th {
        padding: 10px 8px;
        border: 1px solid #eee;
        text-align: left;
    }
    .view-all{
        float: left;
    }
    @media
    only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px)  {

        /* Force table to not be like tables anymore */
        table, thead, tbody, th, td, tr {
            display: block;
        }

        /* Hide table headers (but not display: none;, for accessibility) */
        thead tr {
            position: absolute;
            top: -9999px;
            left: -9999px;
        }

        tr { border: 1px solid #ccc; }

        td {
            /* Behave  like a "row" */
            border: none;
            border-bottom: 1px solid #eee;
            position: relative;
            padding-left: 50%;
        }

        td:before {
            /* Now like a table header */
            position: absolute;
            /* Top/left values mimic padding */
            top: 6px;
            left: 6px;
            width: 45%;
            padding-right: 10px;
            white-space: nowrap;
        }

        /*
        Label the data
        */
        td:nth-of-type(1):before { content: "First Name"; }
        td:nth-of-type(2):before { content: "Last Name"; }
        td:nth-of-type(3):before { content: "Job Title"; }
        td:nth-of-type(4):before { content: "Favorite Color"; }
        td:nth-of-type(5):before { content: "Wars of Trek?"; }
        td:nth-of-type(6):before { content: "Secret Alias"; }
        td:nth-of-type(7):before { content: "Date of Birth"; }
        td:nth-of-type(8):before { content: "Dream Vacation City"; }
        td:nth-of-type(9):before { content: "GPA"; }
        td:nth-of-type(10):before { content: "Arbitrary Data"; }
    }
</style>